import { clearErrors } from "../auth";
import map from "lodash-es/map";

export const OPEN_SIDEMENU = "OPEN_SIDEMENU";
export const CLOSE_SIDEMENU = "CLOSE_SIDEMENU";
export const TOGGLE_SIDEMENU = "TOGGLE_SIDEMENU";
export const UPDATE_LOCATION = "UPDATE_LOCATION";
export const CLOSE_MENU = "CLOSE_MENU";

export const changePage = page => {
	window.history.pushState({}, "", page);
	window.dispatchEvent(new CustomEvent("changePage", { detail: page }));
};

export const loadAuthResources = location => async (dispatch, getState) => {
	const path = window.decodeURIComponent(location.pathname);
	const splitPath = (path || "").slice(1).split("/");
	let page = splitPath[0];

	switch (page) {
		case "login":
			await import("@stofloos/components/pages/sw-auth/sw-auth-form-login/index.js");
			break;
		case "2fa":
			if (getState().StofwareAuth.unfresh_access_token) {
				await import("@stofloos/components/pages/sw-auth/sw-auth-form-otp/index.js");
			} else {
				page = "login";
				dispatch(changePage("/" + page));
				await import("@stofloos/components/pages/sw-auth/sw-auth-form-login/index.js");
			}
			break;
		case "registreren":
			await import("@stofloos/components/pages/sw-auth/sw-auth-form-register/index.js");
			break;
		case "wachtwoord-vergeten":
			await import("@stofloos/components/pages/sw-auth/sw-auth-form-forgot-password/index.js");
			break;
		case "account-bevestigen-1fa":
			await import("@stofloos/components/pages/sw-auth/sw-auth-form-confirm-account/index.js");
			break;
		case "account-bevestigen":
			await import("@stofloos/components/pages/sw-auth/sw-auth-form-confirm-account-2fa/index.js");
			break;
		case "wachtwoord-veranderen":
			await import("@stofloos/components/pages/sw-auth/sw-auth-form-change-password/index.js");
			break;
		case "algemene-voorwaarden":
			await import("@stofloos/components/pages/sw-page-terms/index.js");
			break;
		case "privacy-policy":
			await import("@stofloos/components/pages/sw-page-privacy/index.js");
			break;
		default:
			page = "login";
			dispatch(changePage("/" + page));
			await import("@stofloos/components/pages/sw-auth/sw-auth-form-login/index.js");
	}

	dispatch({
		type: UPDATE_LOCATION,
		page
	});
};

export const updateLocation = location => async (dispatch, getState) => {
	dispatch(clearErrors());
	dispatch(closeMenu());

	const path = window.decodeURIComponent(location.pathname);
	const splitPath = (path || "").slice(1).split("/");
	let page = splitPath[0];
	let pageId = splitPath[1];

	dispatch({
		type: UPDATE_LOCATION,
		page,
		pageId
	});
};

export const closeMenu = () => {
	return {
		type: CLOSE_MENU
	};
};

export const openSideMenu = () => {
	return {
		type: OPEN_SIDEMENU
	};
};

export const closeSideMenu = () => {
	return {
		type: CLOSE_SIDEMENU
	};
};

export const toggleSideMenu = () => {
	return {
		type: TOGGLE_SIDEMENU
	};
};
